type RuntimeEnv = Record<string, string | boolean | undefined>;

const runtimeEnv = import.meta.env as RuntimeEnv;

export const isDevelopment = Boolean(import.meta.env.DEV);
export const isProduction = Boolean(import.meta.env.PROD);

export function getEnvValue(name: string): string | undefined {
  const viteValue = runtimeEnv[`VITE_${name}`];
  if (typeof viteValue === 'string') {
    return viteValue;
  }

  return undefined;
}
